import React from 'react';
import Card from '../../../../shared/components/Card';
import CardSimpleHeader from '../../../../shared/components/CardSimpleHeader';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import CardBody from '../../../../shared/components/CardBody';
import { bindActionCreators } from 'redux';
import * as messageDetailActions from '../shared/actions/messageDetailActions';
import { connect } from 'react-redux';
import Row from '../../../../shared/components/Row';
import Message from './Message';
import PropTypes from 'prop-types';
import ResponseMessageDetail from './ResponseMessageDetail';
import { PsMessage } from '../../PsMessage';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import UserRole from '../../../../shared/model/UserRole';

class MessagesDetailCard extends React.Component {

    componentDidMount() {
        this.getMessage();
        this.markAsReadMessage();
    }

    getMessage() {
        this.props.messageDetailActions.getMessage(this.props.messageId);
    }

    markAsReadMessage() {
        this.props.messageDetailActions.markReadMessage(this.props.messageId);
    }

    renderAddMessage() {
        if ( !this.props.message ) {
            return null;
        }
        return <ResponseMessageDetail messageId={this.props.messageId}/>;
    }

    renderMessage() {
        if ( !this.props.message ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.messageError}</h3>
                </section>
            );
        }
        return (
            <Message
                message={this.props.message}
                canResponse={false}
                canArchive={true}
                showDivider={false}
            />
        );
    }

    render() {
        const {
            currentUser,
        } = this.props;
        const canAddMessage = currentUser.role() !== UserRole.OUTSOURCES_VIEWER;

        return (
            <Row>
                <Card colWidth={'col-md-12'} loading={this.props.messageLoading}>
                    <CardSimpleHeader title={I18nUtils.tr('TR_CONVERSACION')}/>
                    <CardBody>
                        {this.renderMessage()}
                        {canAddMessage && this.renderAddMessage()}
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {
    let errorMessage = state.messageDetail.messageError;
    if ( !errorMessage && state.messageDetail.message === null && !state.messageDetail.messageLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTE_EL_MENSAJE');
    }
    return ( {
        message: state.messageDetail.message && PsMessage.fromAPIMessage(state.messageDetail.message),
        messageLoading: state.messageDetail.messagesLoading,
        messageError: errorMessage,
        currentUser: CurrentUser.fromReduxState(state),
    } );
};

const mapDispatchToProps = dispatch => ( {
    messageDetailActions: bindActionCreators(messageDetailActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(MessagesDetailCard);

MessagesDetailCard.propTypes = {
    messageId: PropTypes.string,
};

MessagesDetailCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/detail/MessagesDetailCard.js